export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/character_animation.3b594eb.svg";